export default function SideBarMenuStikcy () {
    var stickySidebar =  document.querySelector(".sidebar.sticky-right");
    var menuToggle =  document.querySelector("#menu-toggle");
    var wrapper = document.querySelector("#wrapper");
    var menuToggleClose =  document.querySelector("#menu-toggle-close");
    var stickyBarBtns = document.querySelectorAll(".sticky-right ul#menu li a");
    var isMobile = window.innerWidth < 768 || Math.min(window.screen.width, window.screen.height) < 768 || navigator.userAgent.indexOf("Mobi") > -1;

    stickyBarBtns && stickyBarBtns.forEach((item)=>{
        item.addEventListener('click', () => { 
            const linkName = item.parentElement.querySelector("p.sidebar-menu_text").innerHTML;

            window.mParticle && window.mParticle.logEvent(
                "stickybar_clicked", 
                window.mParticle.EventType.Other, 
                {"name": linkName}
            );
        });
    });

    var sidebarWrapper = document.querySelectorAll(".sidebar-wrapper_content");

    var weChatWrapper = document.querySelector(".weChat-content");
    var weChatBtn = document.querySelector(".weChat-qr-code");

    var promoWrapper = document.querySelector(".promotion-content");
    var promoBtn = document.querySelector(".promotion-btn");

    var liveChatBtn = document.querySelector(".live-chat-btn");

    weChatBtn && weChatBtn.addEventListener("click", function (event) { 
        event.preventDefault(); 
        if(promoWrapper.classList.contains('active')){
            promoWrapper.classList.remove('active');
        }

        if (weChatWrapper.classList.contains('active')) {
            weChatWrapper.classList.remove('active');
        } else {
            weChatWrapper.classList.add('active');
        }
    });

    promoBtn && promoBtn.addEventListener("click", function (event) { 
        event.preventDefault(); 
        if(weChatWrapper.classList.contains('active')){
            weChatWrapper.classList.remove('active');
        }

        if (promoWrapper.classList.contains('active')) {
            promoWrapper.classList.remove('active');
        } else {
            promoWrapper.classList.add('active');
        }
    });

    liveChatBtn && liveChatBtn.addEventListener("click", function () { 
        if(promoWrapper.classList.contains('active') || weChatWrapper.classList.contains('active')){
            promoWrapper.classList.remove('active');
            weChatWrapper.classList.remove('active');
        }
    });

    menuToggle && menuToggle.addEventListener("click", function (event) { 
        event.preventDefault(); 
        wrapper.classList.toggle("toggled"); 
        menuToggle.style.visibility = "hidden";
        menuToggle.style.padding= "0";
        menuToggleClose.style.visibility = "visible";
        menuToggleClose.style.padding= "8px";

        if (wrapper && wrapper.classList.contains('toggled')) {
            stickySidebar.style.maxWidth = "80px";
        }
    });

    menuToggleClose && menuToggleClose.addEventListener("click", function (event) { 
        event.preventDefault(); 
        wrapper.classList.toggle("toggled"); 
        menuToggle.style.visibility = "visible";
        menuToggle.style.padding= "8px";
        menuToggleClose.style.visibility = "hidden";
        menuToggleClose.style.padding= "0";

        if (wrapper && !wrapper.classList.contains('toggled')) {
            stickySidebar.style.maxWidth = "45px";
            sidebarWrapper.forEach((item) => {
                item.classList.remove('active');
            });
        }
    });

    if(isMobile) {
        wrapper.classList.toggle("toggled"); 
        stickySidebar.style.maxWidth = "45px";
        menuToggle.style.visibility = "visible";
        menuToggle.style.padding= "8px";
        menuToggleClose.style.visibility = "hidden";
        menuToggleClose.style.padding= "0";
    }
 }